module.exports = __webpack_public_path__ + "static/media/webBlueOutline.f167ce5f.svg";